export function tableToTsv(table: HTMLTableElement): string {
  const clone = table.cloneNode(true) as HTMLTableElement;
  clone.querySelectorAll('[data-copy-exclude]').forEach((el) => el.remove());

  const rows = Array.from(clone.querySelectorAll('tr'));
  return rows
    .map((row) => {
      const cells = Array.from(row.querySelectorAll('th,td'));
      return cells
        .map((cell) =>
          (cell.textContent ?? '')
            .replace(/ /g, ' ')
            .replace(/\s+/g, ' ')
            .replace(/\t/g, ' ')
            // A removed citation marker can leave "word ." behind - collapse that space.
            .replace(/(\S)\s+([.,;:!?])/g, '$1$2')
            .trim(),
        )
        .join('\t');
    })
    .join('\n');
}
